import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { verifyauthCheck, getWinningResultsList } from "../handlers/adminApi";
import { formatPriceInUSD } from '../handlers/helpers';
import { DotLoader } from 'react-spinners'; // Import DotLoader
import { faEye, faTrash, faPenToSquare, faDownload, faChevronDown, faLocationDot, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Papa from 'papaparse';


function Result() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [winningResults, setWinningResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showExportModal, setShowExportModal] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [selectedResults, setSelectedResults] = useState([]); // Track selected results for deletion
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [formData, setFormData] = useState({
    resultDate: '',
    track: '',
    raceNumber: '',
    result: '',
    horseName: '',
    odd: '',
    stake: '',
    amountCollected: '',
    show: '',
    unit: '',
    profitLossUnit: '',
    winPlace: '',
    winLoss: ''
  });
  const navigate = useNavigate();
  const location = useLocation();
  const tipsPerPage = 8; // Set to 8 for displaying 8 results per page

  const totalTips = winningResults.length; // Total number of results
  const totalPages = Math.ceil(totalTips / tipsPerPage); // Calculate total number of pages

  // Calculate the index range for the current page's data
  const indexOfLastEntry = currentPage * tipsPerPage;
  const indexOfFirstEntry = indexOfLastEntry - tipsPerPage;
  const currentTips = winningResults.slice(indexOfFirstEntry, indexOfLastEntry); // Get the results for the current page

  // Handle page change (updates the current page state)
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const openDeleteModal = (id) => {
    setDeleteIndex(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteIndex(null);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const resultId = deleteIndex;
    console.log(`Deleting item with result_id: ${resultId}`);

    if (resultId === null || resultId === undefined) {
      console.error('No valid result_id provided for deletion');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/results/delete-result/${resultId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseData = await response.json();  // Log the response from the API
      console.log('Delete response:', responseData);

      if (response.ok) {
        const updatedResults = winningResults.filter(result => result.result_id !== resultId);
        setWinningResults(updatedResults);
        closeDeleteModal();
        window.location.reload();
      } else {
        console.error('Failed to delete the result');
      }
    } catch (error) {
      console.error('Error occurred while deleting the result:', error);
    }
  };

  const openAddModal = () => {
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    console.log('Saving new result...', formData);

    // Format the resultDate (remove time part if needed)
    const formattedResultDate = moment(formData.resultDate).format("YYYY-MM-DD");

    const dataToSend = {
      ...formData,
      resultDate: formattedResultDate,  // Adjust the date format before sending
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/results/add-result`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),  // Send the formatted date
      });
      console.log('API response status:', response.status);
      const responseData = await response.json();
      console.log('Save response:', responseData);

      if (response.ok) {
        const newResult = responseData;  // Assuming the response returns the added result
        setWinningResults([newResult, ...winningResults]);
        closeAddModal();
        window.location.reload();
      } else {
        console.error('Failed to save the result');
      }
    } catch (error) {
      console.error('Error occurred while saving the result:', error);
    }
  };


  const hasRun = useRef(false);
  const authCheck = async () => {
    var resp = await verifyauthCheck();
    if (resp != null) {
      if (resp.status === true) {
        navigate(location.pathname, {
          state: { ...location.state, userData: resp.userData }
        })
      } else {
        navigate("/")
      }
    }
  };

  const getWinningResults = async () => {
    setLoading(true);
    const allResults = [];
    const totalPages = 5; // Adjust this based on the API response

    for (let page = 1; page <= totalPages; page++) {
      var resp = await getWinningResultsList({ 'page': page.toString() });
      const pageData = _.get(resp, 'data', []);

      allResults.unshift(...pageData);
    }

    const sortedResults = allResults.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    setWinningResults(sortedResults); // Set the state with sorted results
    setLoading(false);
  };


  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      authCheck();
      getWinningResults();
    }
  }, []);


  useEffect(() => {
    getWinningResults(); // Fetch all the results when the component mounts
  }, []);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
    console.log('Updated formData:', formData);
  };
  const handleExportClick = (e) => {
    e.preventDefault();
    setShowExportModal(true);
  };
  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleSaveExport = async () => {
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const validExtensions = ['csv'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      alert("Invalid file extension. Please upload a CSV file.");
      return;
    }

    Papa.parse(file, {
      complete: async (result) => {
        if (result.data.length === 0) {
          alert("The file is empty.");
          return;
        }

        const dataToSend = result.data.map(row => ({
          date: row.date,
          raceNumber: row.race_number, // Maps to formData.raceNumber
          track: row.track,            // Maps to formData.track
          result: row.status,          // Maps to formData.result (assuming result status)
          horseName: row.horse_name,   // Maps to formData.horseName
          odd: row.current_price,      // Maps to formData.odd
          stake: row.betting_unit,     // Maps to formData.stake
          amountCollected: row.analysis, // Maps to formData.amountCollected
          resultDate: row.tip_date,    // Maps to formData.resultDate
          show: row.show,
          unit: row.unit,
          profitLossUnit: row.profit_loss_unit,
          winPlace: row.win_place,
          winLoss: row.win_loss
        }));

        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/admin/results/import-results`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          if (response.status === 200) {
            console.log('File uploaded successfully:', response.data);
            setShowExportModal(false);
            window.location.reload();
          } else {
            console.error('Failed to upload file', response.data);
            alert('Failed to upload file. Please try again.');
          }
        } catch (error) {
          console.error('Error uploading file:', error);
          if (error.response) {
            alert(`Server error: ${error.response.status}`);
          } else if (error.request) {
            alert('No response from server. Please check your internet connection or try again later.');
          } else {
            alert('An error occurred while uploading the file.');
          }
        }
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
        alert('There was an error parsing the CSV file. Please try again.');//onClick={handleExportClick}                   <FontAwesomeIcon icon={faDownload} />

      }
    });
  };

  const handleCloseModal = () => {

    setShowExportModal(false);
  };
  const handleSelectAllChange = () => {
    if (selectAllChecked) {
      setSelectedResults([]); // If Select All is checked, uncheck all
    } else {
      const allIds = winningResults.map((tip) => tip.result_id); // Get all result IDs from the list
      setSelectedResults(allIds); // Select all results
    }
    setSelectAllChecked(!selectAllChecked); // Toggle the Select All state
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (resultId) => {
    setSelectedResults(prevSelected => {
      let newSelected;
      if (prevSelected.includes(resultId)) {
        newSelected = prevSelected.filter(id => id !== resultId); // Remove the ID if it's already selected
      } else {
        newSelected = [...prevSelected, resultId]; // Add the ID to the selection
      }

      // Check if all results are selected
      setSelectAllChecked(newSelected.length === winningResults.length);
      return newSelected;
    });
  };

  const handleDeleteSelected = async () => {
    console.log("Selected results before API call:", selectedResults);  // Log selectedResults

    const selectedIds = selectedResults;

    if (selectedIds.length === 0) {
      alert("No results selected for deletion.");
      return;
    }

    try {
      // Instead of passing the IDs as query string, send them in the request body
      const response = await fetch(`${process.env.REACT_APP_API_HOSTNAME}/admin/results/delete-all-results`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ids: selectedIds }),  // Send the IDs as JSON
      });

      console.log('API response status:', response.status);
      console.log('API response statusText:', response.statusText);
      console.log('API response headers:', response.headers);

      // Parse the response body
      const responseData = await response.json();
      console.log('API response body:', responseData);

      // Check if the deletion was successful
      if (response.ok && responseData.status) {
        console.log('Delete response:', responseData);

        // Update UI by removing the deleted results
        const updatedResults = winningResults.filter(result => !selectedIds.includes(result.result_id));
        setWinningResults(updatedResults);
        alert('Selected results deleted successfully!');
      } else {
        console.error('Failed to delete the result with IDs:', selectedIds, responseData.message);
        alert('Error deleting selected results.');
      }
    } catch (error) {
      console.error('Error occurred while deleting selected results:', error);
      alert('An error occurred while deleting the selected results. Please try again.');
    }
  };

  return (
    <div className="result-main" style={{ overflow: "hidden" }}>
      <div className="middle">
        <div className="right3">
          <div className="title">
            <h2>Result</h2>
          </div>

          {loading ? (
            <div className="loader-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
              <DotLoader color="#F7812A" loading={loading} size={60} />
            </div>
          ) : (
            <div className="table">

              <div className="button-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="export-button-container">

                  <a className="export-button1" style={{ cursor: 'pointer' }} >
                    <input
                      type="checkbox"
                      style={{
                        borderColor: 'orange',
                        outline: 'none',
                        cursor: 'pointer',
                        width: '17px',
                        height: '17px'
                      }}
                      checked={selectAllChecked}  // Bind the "Select All" checkbox state
                      onChange={handleSelectAllChange}
                    />
                    Select All
                  </a>
                </div>
                <div className="add-new-list-container">
                  <a style={{ cursor: 'pointer' }} className="add-new-list-button" onClick={openAddModal}>+ Add Result</a>
                </div>
                <div className="export-button-container">
                  <a style={{ cursor: 'pointer' }} className="export-button" onClick={handleExportClick}>
                    <FontAwesomeIcon icon={faDownload} />
                    Result Import
                  </a>
                </div>
                <div className="export-btn-container" style={{ marginLeft: 'auto', marginRight: '10px', cursor: 'pointer' }}>
                  <a className="export-btn" onClick={handleDeleteSelected}>
                    Delete Result
                  </a>
                </div>
              </div>

  <div className="table-wrapper" style={{ overflowX: 'auto' }}> 
              <table className='table-content'>
                <tr>
                  <th>Date</th>
                  <th>Track</th>
                  <th>Result Type</th>
                  <th>Race Number</th>
                  <th>Horse name</th>
                  <th>Result</th>
                  <th>Win/Place</th>
                  <th>Win/Loss</th>
                  <th>Unit</th>
                  <th>Profit/Loss (Unit)</th>
                  <th>Odds</th>
                  <th>Stake</th>
                  <th>Collected</th>
                </tr>

                {currentTips.map((tip, index) => (
                  <tr key={index}>
                    <td style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                      <input
                        type="checkbox"
                        style={{
                          borderColor: 'orange',
                          outline: 'none',
                          cursor: 'pointer',
                          width: '20px',
                          height: '17px'
                        }}
                        checked={selectedResults.includes(tip.result_id)}
                        onChange={() => handleCheckboxChange(tip.result_id)} />
                      <span style={{ marginLeft: '10px' }}>
                        {moment(tip.result_date).format("D MMMM YYYY")}
                      </span>


                    </td>
                    <td>{tip.track}</td>
                    <td>{tip.where_to_show}</td>

                    <td style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginLeft: '50px' }}>{tip.race_number}</span>
                    </td>
                    <td>{tip.horse_name}</td>
                    <td>{tip.result}</td>
                    <td>{tip.win_place}</td>
                    <td>{tip.win_loss}</td>
                    <td>{tip.unit}</td>
                    <td>{tip.profit_loss_unit}</td>
                    <td>{formatPriceInUSD(tip.odd)}</td>
                    <td>{formatPriceInUSD(tip.stake)}</td>
                    <td>
                      {formatPriceInUSD(tip.amount_collected)}
                      <a onClick={(e) => openDeleteModal(tip.result_id)} style={{ color: 'red', marginLeft: 10, cursor: 'pointer' }}>
                        <FontAwesomeIcon icon={faTrash} style={{ color: 'red', marginLeft: 20 }} />
                      </a>
                    </td>
                  </tr>
                ))}
              </table>
                </div>
              <hr className="horizontal-line" />

              <div className="pagination">
                <span>
                  Showing  {Math.min(indexOfLastEntry, totalTips)} of {totalTips} entries
                </span>
                <div className="pagination-buttons">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={currentPage === index + 1 ? 'active' : ''}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="edit-form change-sub">
            <div className="form">
              <form>
                <h2>Delete</h2>
                <p>Are you sure you want to Delete?</p>

                <div className="theme-btn log-out">
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }}
                      onClick={handleDelete}>Delete</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }}
                      onClick={closeDeleteModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Add Result Modal */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="edit-form result-edit">
            <div className="form">
              <form>
                <h2>Add Result</h2>

                {/* Result Date */}
                <div className="form-group">
                  <label htmlFor="resultDate">Date</label>
                  <input
                    type="date"
                    id="resultDate" // Matches the state key
                    value={formData.resultDate}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Track */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="track">Track</label>
                    <input
                      type="text"
                      id="track" // Matches the state key
                      value={formData.track}
                      onChange={handleInputChange}
                      placeholder="Enter Track"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="show">Result Type</label>
                    <select
                      id="show"  // This ID corresponds to the 'show' field in your formData
                      value={formData.show}  // Bind it to the correct state field
                      onChange={handleInputChange}  // Handle the change for the dropdown
                    >
                      <option value="">Select Type</option>
                      <option value="Notable Whooska">Notable Whooska</option>
                      <option value="Result Page">Result Page</option>
                    </select>
                  </div>

                </div>



                {/* Race Number and Bet Type */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="raceNumber">Race Number</label>
                    <input
                      type="text"
                      id="raceNumber" // Matches the state key
                      value={formData.raceNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Race Number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="result ">Bet Type</label>
                    <input
                      type="text"
                      id="result" // Matches the state key (Bet Type)
                      value={formData.result}
                      onChange={handleInputChange}
                      placeholder="eg. Single, Double"
                    />
                  </div>
                </div>
                {/* Win/Place and Win Loss */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="winPlace">Win/Place</label>
                    <input
                      type="text"
                      id="winPlace" // Matches the state key
                      value={formData.winPlace}
                      onChange={handleInputChange}
                      placeholder="Enter Win/Place"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="winLoss">Win/Loss</label>
                    <input
                      type="text"
                      id="winLoss" // Matches the state key (Win/Loss)
                      value={formData.winLoss}
                      onChange={handleInputChange}
                      placeholder="eg. 2nd,1st, 3rd"
                    />
                  </div>
                </div>
                {/* Unit and Profit&Losst(Unit)*/}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="unit">Unit</label>
                    <input
                      type="text"
                      id="unit" // Matches the state key
                      value={formData.unit}
                      onChange={handleInputChange}
                      placeholder="Enter Unit"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="profitLossUnit">Profit/Loss(Unit)</label>
                    <input
                      type="text"
                      id="profitLossUnit" // Matches the state key (Profit/Loss)
                      value={formData.profitLossUnit}
                      onChange={handleInputChange}
                      placeholder="eg. 0.00,45.12"
                    />
                  </div>
                </div>
                {/* Horse Name and Odds */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="horseName">Horse Name</label>
                    <input
                      type="text"
                      id="horseName" // Matches the state key
                      value={formData.horseName}
                      onChange={handleInputChange}
                      placeholder="Horse Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="odd">Odds</label>
                    <input
                      type="text"
                      id="odd" // Matches the state key
                      value={formData.odd}
                      onChange={handleInputChange}
                      placeholder="Odd Amount"
                    />
                  </div>
                </div>

                {/* Stake and Amount Collected */}
                <div className="form-feild">
                  <div className="form-group">
                    <label htmlFor="stake">Stake</label>
                    <input
                      type="text"
                      id="stake" // Matches the state key
                      value={formData.stake}
                      onChange={handleInputChange}
                      placeholder="$ Enter amount"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="amountCollected">Collected</label>
                    <input
                      type="text"
                      id="amountCollected" // Matches the state key
                      value={formData.amountCollected}
                      onChange={handleInputChange}
                      placeholder="$ Enter amount"
                    />
                  </div>
                </div>

                {/* Save/Cancel Buttons */}
                <div className="theme-btn" style={{ marginTop: 50, marginBottom: 30 }}>
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }} onClick={handleSave}>Save Changes</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }} onClick={closeAddModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}



      {showExportModal && (
        <div className="modal-overlay">
          <div className="edit-form import-tip" >
            <div className="form">
              <form action="">
                <h2>Import Result</h2>

                <div className="form-group fullname" >
                  <input
                    className="file-input"
                    type="file"
                    name="file"
                    ref={fileInputRef} // Reference to the file input
                    hidden
                    onChange={handleFileChange}
                  />
                  <FontAwesomeIcon
                    icon={faCloudUploadAlt} // Use the FontAwesomeIcon component
                    size="2x"
                    onClick={handleIconClick} // Adjust icon size as needed
                    style={{ marginBottom: '-80px' }}
                  />
                  <p style={{ marginBottom: '10px' }}>
                    {fileName ? `Selected File: ${fileName}` : 'Browse File to Upload'}
                  </p>
                </div>

                <div className="theme-btn">
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }} onClick={handleSaveExport}>Upload</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }} onClick={handleCloseModal}>Cancel</a>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      )
      }
    </div>
  );
}

export default Result;
